<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <g clip-path="url(#clip0_202_423)">
    <path
      d="M10 0L12.843 6.65214L20 7.32102L14.6 12.1011L16.1803 19.1667L10 15.4688L3.81966 19.1667L5.4 12.1011L0 7.32102L7.15704 6.65214L10 0Z"
      fill="#F9C039"
    />
  </g>
  <defs>
    <clipPath id="clip0_202_423">
      <rect width="20" height="20" fill="white" />
    </clipPath>
  </defs>
</svg>
